<template>
  <BasePopoverNav
    :style="{
      top: '60px'
    }"
    arrow="topLeft"
    :keepVisibleOn="keepVisibleOn"
    autoPositioning
    :positionOn="positionOn"
    :items="
      [
        {
          name: 'calendar-settings',
          icon: 'settings',
          label: $t('calendar.nav.calendar_settings'),
          routeName: 'admin-calendar',
        },
        {
          name: 'roster-settings',
          icon: 'calendar',
          label: $t('calendar.nav.roster_settings'),
          routeName: 'admin-roster',
        },
        {
          name: 'service-settings',
          icon: 'scissors',
          label: $t('calendar.nav.service_settings'),
          routeName: 'admin-services',
        },
        {
          name: 'online-booking',
          icon: 'globe',
          label: $t('calendar.nav.online_booking'),
          routeName: 'admin-online-bookings',
        },
        {
          name: 'appointment-requests',
          icon: 'message-circle',
          label: $t('calendar.appointment_requests.heading'),
          hide: !unleash.isEnabled('AppointmentConfirmationEnabled'),
          routeName: 'appointment-requests',
        },
        {
          name: 'print-calendar',
          icon: 'printer',
          label: $t('calendar.nav.print_calendar')
        }
      ].filter((item) => !item.hide)
    "
    @close="$emit('close')"
    @select="onSelect"
  />
</template>

<script
  setup
  lang="ts"
>
import config from '@/config';
import dayjs from '@/dayjs';
import { getDateRangeWeek } from '@/modules/calendar/helpers';
import { useCalendarFiltersStore } from '@/stores/calendar-filters';
import unleash from '@/unleash';

defineProps<{
  keepVisibleOn: HTMLElement;
  positionOn: HTMLElement;
}>();

defineEmits(['close']);

const onSelect = (item: { name: string }) => {
  if (item.name === 'print-calendar') {
    const { viewType, date } = useCalendarFiltersStore();

    const { start, end } =
      viewType === 'WEEK'
        ? getDateRangeWeek(date)
        : viewType === 'MONTH'
          ? {
              start: dayjs(date).startOf('month').format('YYYY-MM-DD'),
              end: dayjs(date).endOf('month').format('YYYY-MM-DD'),
            }
          : { start: date, end: date };
    window.open(`${config.backendUrl}/appointments?start=${start}&end=${end}`);
  }
};
</script>
